import * as React from 'react';
import { cn } from '../../lib/utils';
import type { FloatingLabelProps } from './types';

export const FloatingLabel = React.forwardRef<
  HTMLDivElement,
  FloatingLabelProps
>(
  (
    {
      label,
      float = 'left',
      htmlFor,
      children,
      className,
      labelClassName,
      labelFloatClassName,
      leftSlot,
      rightSlot,
      required,
      disabled,
      renderAsSpan,
      ...props
    },
    ref,
  ) => {
    const Comp = renderAsSpan ? 'span' : 'label';

    return (
      <div
        {...props}
        ref={ref}
        className={cn(
          'eye:flex eye:h-[44px] eye:items-center eye:rounded-md',
          'eye:border eye:border-grey-100 eye:px-12 eye:py-[10px]',
          'eye:gap-4 eye:text-16 eye:font-regular eye:outline-offset-3',
          'eye:relative eye:focus-within:outline-2 eye:hover:border-black',
          className,
          float === 'left' && 'eye:bg-white',
          float === 'top' && 'eye:mt-12',
          disabled && 'eye:disabled',
        )}
      >
        {leftSlot}

        <Comp
          {...(Comp === 'label' && htmlFor ? { htmlFor } : {})}
          className={cn(
            'eye:body-m eye:flex eye:w-full eye:items-center eye:gap-4',
            labelClassName,
          )}
        >
          {label && (
            <span
              className={cn(
                'eye:body-s eye:font-semibold eye:text-nowrap',
                float === 'top' &&
                  'eye:absolute eye:top-[-9px] eye:left-[10px] eye:bg-white eye:px-[1px] eye:leading-16',
                labelFloatClassName,
              )}
            >
              {label} {required && <span aria-hidden={true}>*</span>}
            </span>
          )}
          {children}
        </Comp>
        {rightSlot}
      </div>
    );
  },
);

FloatingLabel.displayName = 'FloatingLabel';
